import { type ConfirmationModalProps, ConfirmationModal, Text } from '@shared/components';

type PendingQuestionModalProps = Pick<
  ConfirmationModalProps,
  'loading' | 'open' | 'onAccept' | 'onClose'
>;

export default function PendingQuestionModal(props: Readonly<PendingQuestionModalProps>) {
  const { loading: isLoading, open: isOpen, onClose, onAccept } = props;

  return (
    <ConfirmationModal
      title='Update Status to Pending?'
      open={isOpen}
      loading={isLoading}
      acceptText='Update'
      content={
        <Text>
          เมื่อทำการ Pending คำถามนี้{' '}
          <Text variant='body1Semibold' component='span'>
            ระบบจะไม่นำคำถามนี้ไปใช้ในการ Generate ชุดข้อสอบ
          </Text>
          <br />
          <br />
          กรุณาตรวจสอบความถูกต้องให้เรียบร้อยก่อนดำเนินการต่อ
        </Text>
      }
      onDiscard={onClose}
      onClose={onClose}
      onAccept={onAccept}
    />
  );
}
